export const filmCategories = [
  { key: "all", label: "全部" },
  { key: "family", label: "家庭亲情" },
  { key: "marriage", label: "婚姻情感" },
  { key: "society", label: "社会议题" },
  { key: "growth", label: "成长与自我" },
];

export const films = [
  {
    id: "kramer",
    title: "克莱默夫妇",
    original: "Kramer vs. Kramer",
    year: 1979,
    region: "美国",
    category: "family",
    tags: ["离婚", "抚养", "父子"],
    note: "以一场离婚争夺抚养权的过程，展开父母与孩子之间责任与亲密的重建，是家庭伦理片被反复引用的起点之一。",
  },
  {
    id: "manchester",
    title: "海边的曼彻斯特",
    original: "Manchester by the Sea",
    year: 2016,
    region: "美国",
    category: "family",
    tags: ["创伤", "监护", "愧疚"],
    note: "一个无法与自己和解的成年人被迫回到故乡处理家事，镜头冷静地记录悲伤如何成为日常的一部分。",
  },
  {
    id: "amour",
    title: "爱",
    original: "Amour",
    year: 2012,
    region: "法国",
    category: "family",
    tags: ["老年", "照护", "陪伴"],
    note: "把镜头放在一对老年伴侣的室内生活里，讨论疾病、照护与尊严，几乎没有煽情，却格外沉重。",
  },
  {
    id: "august",
    title: "八月：奥色治郡",
    original: "August: Osage County",
    year: 2013,
    region: "美国",
    category: "family",
    tags: ["家族", "坦白", "争执"],
    note: "一次家庭聚会变成把陈年秘密逐层揭开的对峙，群戏密集，是研究家庭关系的文本型作品。",
  },
  {
    id: "room",
    title: "房间",
    original: "Room",
    year: 2015,
    region: "爱尔兰",
    category: "family",
    tags: ["母子", "重建", "自由"],
    note: "前半段是被困住的母子日常，后半段是走出困境之后的适应问题，重心落在亲情与心理重建上。",
  },
  {
    id: "marriage-story",
    title: "婚姻故事",
    original: "Marriage Story",
    year: 2019,
    region: "美国",
    category: "marriage",
    tags: ["离婚", "沟通", "律师"],
    note: "用双视角讲一段关系如何从相爱走到分开，重点不在谁对谁错，而在两个人如何逐渐听不懂彼此。",
  },
  {
    id: "revolutionary-road",
    title: "革命之路",
    original: "Revolutionary Road",
    year: 2008,
    region: "美国",
    category: "marriage",
    tags: ["中年", "理想", "窒息"],
    note: "一对看起来体面的夫妻被困在郊区生活里，讨论婚姻、自我期待与不甘心之间的长期拉扯。",
  },
  {
    id: "blue-valentine",
    title: "蓝色情人节",
    original: "Blue Valentine",
    year: 2010,
    region: "美国",
    category: "marriage",
    tags: ["时间线", "倦怠", "真实"],
    note: "把相恋与破裂两条时间线交叉剪辑，呈现出感情从热烈到疲态的对照，风格写实而克制。",
  },
  {
    id: "her",
    title: "她",
    original: "Her",
    year: 2013,
    region: "美国",
    category: "marriage",
    tags: ["亲密", "孤独", "未来"],
    note: "借一段人与操作系统的关系，把亲密、陪伴与孤独的话题放进近未来的语境里讨论。",
  },
  {
    id: "gone-girl",
    title: "消失的爱人",
    original: "Gone Girl",
    year: 2014,
    region: "美国",
    category: "marriage",
    tags: ["悬疑", "舆论", "表演"],
    note: "婚姻的表象与媒体叙事被同时拆解，用悬疑外壳探讨一段关系里谁在定义真相。",
  },
  {
    id: "before-sunrise",
    title: "爱在黎明破晓前",
    original: "Before Sunrise",
    year: 1995,
    region: "美国",
    category: "marriage",
    tags: ["对话", "邂逅", "城市"],
    note: "几乎全靠两个人在城市里走路聊天完成，是观察亲密关系如何靠对话建立的代表性作品。",
  },
  {
    id: "american-beauty",
    title: "美国丽人",
    original: "American Beauty",
    year: 1999,
    region: "美国",
    category: "society",
    tags: ["郊区", "中年", "幻灭"],
    note: "以郊区中产家庭的表面生活为切口，讨论体面之下的空虚、欲望与自我欺骗。",
  },
  {
    id: "crash",
    title: "撞车",
    original: "Crash",
    year: 2004,
    region: "美国",
    category: "society",
    tags: ["群像", "偏见", "城市"],
    note: "多组人物在城市里彼此交错，用一整天的事件串联起偏见、误解与善意的灰色地带。",
  },
  {
    id: "three-billboards",
    title: "三块广告牌",
    original: "Three Billboards Outside Ebbing, Missouri",
    year: 2017,
    region: "美国",
    category: "society",
    tags: ["愤怒", "小镇", "和解"],
    note: "一位母亲的追问把小镇的愤怒、偏见与悔意全部掀开，讨论正义与谅解并不总是站在同一边。",
  },
  {
    id: "spotlight",
    title: "聚焦",
    original: "Spotlight",
    year: 2015,
    region: "美国",
    category: "society",
    tags: ["调查", "媒体", "责任"],
    note: "以新闻调查的流程为主轴，冷静呈现机构、责任与个人良心之间的角力。",
  },
  {
    id: "moonlight",
    title: "月光男孩",
    original: "Moonlight",
    year: 2016,
    region: "美国",
    category: "growth",
    tags: ["成长", "身份", "三个阶段"],
    note: "用三个年龄阶段串起一个人的成长，讨论身份认同、脆弱与如何被环境塑造。",
  },
  {
    id: "boyhood",
    title: "少年时代",
    original: "Boyhood",
    year: 2014,
    region: "美国",
    category: "growth",
    tags: ["成长", "时间", "家庭"],
    note: "用多年时间跨度跟拍同一个男孩的成长，把时间本身当成叙事的核心主题。",
  },
  {
    id: "good-will-hunting",
    title: "心灵捕手",
    original: "Good Will Hunting",
    year: 1997,
    region: "美国",
    category: "growth",
    tags: ["天赋", "疗愈", "友情"],
    note: "一个天赋过人的年轻人与心理辅导者的对话，讨论信任、选择与自我价值。",
  },
  {
    id: "lost-in-translation",
    title: "迷失东京",
    original: "Lost in Translation",
    year: 2003,
    region: "美国",
    category: "growth",
    tags: ["孤独", "异乡", "陪伴"],
    note: "两个身处异乡的失眠者在陌生城市里短暂相遇，讨论孤独感与无言的陪伴。",
  },
  {
    id: "brokeback",
    title: "断背山",
    original: "Brokeback Mountain",
    year: 2005,
    region: "美国",
    category: "growth",
    tags: ["克制", "年代", "隐忍"],
    note: "用跨越多年的克制表达，讨论社会压力下个人情感如何被压抑与保存。",
  },
];